import { render, staticRenderFns } from "./AddFunds.vue?vue&type=template&id=1ad65230"
import script from "./AddFunds.vue?vue&type=script&lang=js"
export * from "./AddFunds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports